export const ClaimCategory = {
  HC : "HC",
  PPHC : "PPHC",
  HC_PPHC : "HC+PPHC",
  PARTIAL : "PARTIAL",
  OPD : "OPD",
}

